var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"standarts-catalog-pages"}},[_c('PageTitle',{attrs:{"title":"Cтандарты медицинской помощи","icon":""}}),(_vm.isLoggedIn)?_c('StandartsCatalogGroup'):_c('LoadingImg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }